import React, { Component } from 'react';
import { connect } from "react-redux";
import actions from 'store/actions';
import { ApiKeyHistoryList, LoadingOverlay, FullHeightContainerLayout } from "components";
import { showError } from 'common/ToastNotifications';
import { withRouter } from "react-router";
import { Typography, Empty } from 'antd';

const { Title, Text } = Typography;

class EventApiKey extends Component {

    constructor(props) {
        super(props);
        this.state = {
            fetchingData: true
        }
    }

    // Events raised before the api key migration still carry clientId / clientName.
    getApiKeyId = () => this.props.apiKeyId || this.props.clientId;

    getApiKeyName = () => this.props.apiKeyName || this.props.name || this.props.clientName || this.getApiKeyId();

    componentWillMount() {
        if (!this.props.itemOperation) {
            this.setState({
                busy: true,
                busyMessage: "Getting API key...",
            });
            this.props.getEventApiKey(this.props.eventId, this.getApiKeyId());
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        this.onGetEventApiKeyResultUpdate(prevProps);
    }

    onGetEventApiKeyResultUpdate = (prevProps) => {
        if (this.props.getEventApiKeyResult && this.props.getEventApiKeyResult !== prevProps.getEventApiKeyResult) {
            if (!this.props.getEventApiKeyResult.success) {
                if (this.props.getEventApiKeyResult.code === "PERMISSION_DENIED") {
                    this.setState({
                        permissionDenied: true
                    });
                }
                else {
                    showError("Unable to get API key at this moment.");
                }
            }
            this.setState({
                busy: false,
                busyMessage: "",
                fetchingData: false
            });
        }
    }

    isBusy = () => {
        let isBusy = (this.state.busy || this.state.fetchingData);
        return isBusy;
    }

    render() {
        return (
            <>
                {
                    this.isBusy()
                        ?
                        <LoadingOverlay
                            busy={true}
                            spinner
                            message={this.state.busyMessage || "Please wait..."}>
                        </LoadingOverlay>
                        :
                        <></>
                }
                {
                    !this.state.fetchingData
                        ?
                        <FullHeightContainerLayout
                            showHeader={true}
                            showFooter={false}
                            header={<Title level={5}><Text>Event Revision - </Text><Text type="secondary" italic>{`(API Key: ${this.getApiKeyName()})`}</Text></Title>}
                            content={this.props.apiKeyRevision ?
                                <ApiKeyHistoryList
                                    apiKeyRevisions={[this.props.apiKeyRevision]}>
                                </ApiKeyHistoryList>
                                :
                                <Empty></Empty>}>
                        </FullHeightContainerLayout>
                        :
                        <></>
                }
            </>);
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        getEventApiKeyResult: state.eventApiKey.getEventApiKeyResult,
        apiKeyRevision: state.eventApiKey.apiKeyRevision
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        getEventApiKey: (eventId, apiKeyId) => dispatch(actions.getEventApiKeyRequest(eventId, apiKeyId))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(EventApiKey));
